import type { IconProps } from './IconProps';

export function RefreshIcon({ className }: IconProps) {
  return (
    <svg className={className} width="1em" height="1em" viewBox="0 0 24 24"
      fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
      strokeLinejoin="round" aria-hidden="true" focusable="false">
      <path d="M20 4v6h-6M20 10a8 8 0 1 0-1 8" />
    </svg>
  );
}
